import React, { useCallback, useContext } from 'react';

import { PersonContext } from '../../context/person.provider';

import { AssetHeader } from './asset-header';
import { ValueDisplay } from './value-display';

interface Person {
  id: string;
  firstName: string;
  lastName: string;
  contactEmail?: string;
  contactPhone?: string;
}

interface ExecutorProps {
  onRemove: (executor: Person) => void;
}

export function Executor({ onRemove }: ExecutorProps) {
  const { person: executor } = useContext(PersonContext);

  const handleRemove = useCallback(() => {
    onRemove(executor);
  }, [ executor, onRemove ]);

  const fullName = `${executor.firstName} ${executor.lastName}`;

  return (
    <div className="executor-item">
      <AssetHeader 
        asset={{ name: fullName, type: 'Executor' }}
        handleRemove={handleRemove}
      />
      <div className="value-display-container">
        <ValueDisplay label="Email" value={executor.contactEmail} />
        <ValueDisplay label="Phone" value={executor.contactPhone} />
      </div>
    </div>
  );
}
